import React, { useState } from 'react';
import { Layout, Card, Spin } from 'antd';
import PageTitle from 'shared_components/page_title';
import SearchPager from 'shared_components/search_pager';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';

import SearchForm from "./searchForm";
import SearchTable from "./searchTable";
// import dataSource from './sampleData';

import '../invoice.css'

const {Content} = Layout;

function Search() {
    const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE);
    const [searchLoading, setSearchLoading] = useState(false);
    const [data, setData] = useState([]);

    function search(payload) {
        setData(payload);
        // console.table(payload);
    }

    function handleSearchStart() {
        setSearchLoading(true);
    }

    function handleSearchEnd() {
        setSearchLoading(false);
    }

    const handleChangeSize = (pageSize) => {
		setPageSize(pageSize);
	}

    return (
        <div>
            <Card>
                <PageTitle pageTitle="INVOICE" />
                <Content>
                    <SearchForm 
                        onFinish={search} 
                        onSearchStart={handleSearchStart}
                        onSearchEnd={handleSearchEnd}
                    />
                    <SearchPager 
                        pageTotal={data.length === null ? 0 : data.length}
                        pageSize={pageSize}
                        handleChangeSize={handleChangeSize}
                    />
                    <Spin spinning={searchLoading} tip="Searching...">
                        <SearchTable data={data} pageSize={pageSize} />
                    </Spin>
                </Content>
            </Card>
        </div>
    );
}

export default Search;